// src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Siempre que cambie la ruta, subimos al inicio
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // puedes usar "smooth" si quieres animación
    });
  }, [pathname]);

  return null;
}
